import { z } from 'zod'

export const ClientType = z.enum(['FE', 'MB'])
export type ClientType = z.infer<typeof ClientType>
